var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",attrs:{"id":"home-banner"}},[_c('div',{attrs:{"id":"text-banner"}},[_c('v-img',{attrs:{"src":require('@/assets/logo-tsukigo.png'),"width":"400px","alt":"Tsukigo"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }